// NOTE: this is used to provide default value for object-format component data with multiple level keys, like: config
// import deepGet from "lodash/get"
import defaultsDeep from "lodash/defaultsDeep"

// function isPureObject(value) {
//   return typeof value === 'object' && !Array.isArray(value) && value !== null
// }

export default function(objectWithDefaults, dataModel) {
  return defaultsDeep(dataModel, objectWithDefaults)
  // const provideDefaultForObject = function (objectWithDefaults, dataModel) {
  //   Object.keys(objectWithDefaults).forEach(key => {
  //     if (isPureObject(objectWithDefaults[key])) {
  //       objectWithDefaults[key] = provideDefaultForObject(objectWithDefaults[key], deepGet(dataModel, key, null))
  //     } else {
  //       objectWithDefaults[key] = deepGet(dataModel, key, objectWithDefaults[key])
  //     }
  //   })

  //   return objectWithDefaults
  // }

  // return provideDefaultForObject(objectWithDefaults, dataModel)
}
